export function normalizeSearchText(value?: string | null): string {
  return (value ?? '')
    .toLowerCase()
    .replace(/[^0-9a-z\u00c0-\u024f]+/g, ' ')
    .trim();
}

export function getSearchTokens(searchText?: string | null): string[] {
  const normalized = normalizeSearchText(searchText);
  return normalized.length > 0 ? normalized.split(' ') : [];
}

export function matchesSearchTokens(
  target: string | null | undefined,
  tokens: string[],
): boolean {
  if (tokens.length === 0) {
    return true;
  }

  const normalizedTarget = normalizeSearchText(target);
  if (normalizedTarget.length === 0) {
    return false;
  }

  return tokens.every((token) => normalizedTarget.includes(token));
}
